import React from 'react';
import { connect } from 'react-redux';
import { IC_ROLES } from '../../../base/conference/icRoles';
import SignLangThumbnailWrapper from './SignLangThumbnailWrapper';
const SignLangTranslatorFilmStrip = (props) => (React.createElement("span", { className: 'signlang-filmstrip' }, props._remoteParticipants.map((participant, _) => {
    const participantId = participant;
    return (React.createElement(SignLangThumbnailWrapper, { key: participantId, participantId: participantId, ...props }));
})));
/**
 * Maps (parts of) the Redux state to the associated {@code Filmstrip}'s props.
 *
 * @param {Object} state - The Redux state.
 * @param {any} _ownProps - Components' own props.
 * @private
 * @returns {IProps}
 */
function _mapStateToProps(state, _ownProps) {
    const { remoteParticipants: remoteParticipantsOriginal } = state['features/filmstrip'];
    const { assistant } = state['features/inklusiva/userdata'];
    let remoteParticipants = [];
    if (assistant.signLang.display === 'window') {
        const { conference } = state['features/base/conference'];
        remoteParticipantsOriginal?.forEach((participantId) => {
            if (conference?.checkMemberHasRole(participantId, IC_ROLES.SIGN_LANG_TRANSLATOR)) {
                remoteParticipants.push(participantId);
            }
        });
    }
    else {
        remoteParticipants = [];
    }
    const { clientHeight, clientWidth } = state['features/base/responsive-ui'];
    return {
        _filmstripHeight: clientHeight,
        _filmstripWidth: clientWidth,
        _remoteParticipants: remoteParticipants,
        _remoteParticipantsLength: remoteParticipants.length
    };
}
export default connect(_mapStateToProps)(SignLangTranslatorFilmStrip);
